<link href="https://kendo.cdn.telerik.com/2022.3.913/styles/kendo.common.min.css" rel="stylesheet" />
<link href="https://kendo.cdn.telerik.com/2022.3.913/styles/kendo.blueopal.min.css" rel="stylesheet" />

<!--fnoportalai.azurewebsites.net  localhost:44365-->
<ng-template #content let-c="close" let-d="dismiss" class="modal-lg">
  <div class="modal-header">
    <h4 class="modal-title">Report Model</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> 
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <tr-viewer #viewer2 [containerStyle]="viewerContainerStyle"
                  [serviceUrl]="'https://fnoportalai.azurewebsites.net/api/reports/'"
                   [reportSource]="reportsource"
                   [scaleMode]="'SPECIFIC'"
                   [scale]="1.0"
                   [viewMode]="'PrintPreview'"
                   [enableAccessibility]="true"
                   [showPrint]="true"
                   [printMode]="'AUTO_SELECT'">
          <!-- [viewMode]="'PrintPreview'" [PrintMode]="'Direct' [serviceUrl]="''""-->

        </tr-viewer>
      </div>
    </div>
  </div>
  <script type="text/javascript">
    ReportViewer.prototype.PrintReport = function () {
      switch (this.defaultPrintFormat) {
        case "Default":
          this.DefaultPrint();
          break;
        case "PDF":
          this.PrintAs("PDF");
          previewFrame = document.getElementById(this.previewFrameID);
          previewFrame.onload = function () { previewFrame.contentDocument.execCommand("print", true, null); }
          break;
      }
    };
  </script>
  <!--<div class="modal-footer">-->
  <!--<button (click)="onButtonClick()">Update parameter value</button>-->
  <!--<button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>-->
  <!--</div>-->
</ng-template>
<!--<button type="button" class="btn btn-outline-info mr-2 mb-1" (click)="open(content)"><i class="fa fa-info mr-1"></i>Disc</button>-->
